var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-form",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              attrs: {
                cols: "11"
              }
            },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _c("gg-select", {
                        attrs: {
                          outlined: "",
                          items: _vm.select.action,
                          "item-text": "title",
                          "item-value": "value"
                        },
                        on: {
                          change: _vm.changed
                        },
                        model: {
                          value: _vm.model.action,
                          callback: function callback($$v) {
                            _vm.$set(_vm.model, "action", $$v)
                          },
                          expression: "model.action"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _vm.model.action === "deliver"
                        ? _c("gg-text-field", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: _vm.validation_rules.redirect,
                                expression: "validation_rules.redirect"
                              }
                            ],
                            attrs: {
                              outlined: "",
                              label: "Redirect to email",
                              "data-vv-name": "deliver",
                              "data-vv-as": "Redirect to email",
                              "error-messages": _vm.errors.collect("deliver")
                            },
                            on: {
                              input: _vm.changed
                            },
                            model: {
                              value: _vm.model.dest,
                              callback: function callback($$v) {
                                _vm.$set(_vm.model, "dest", $$v)
                              },
                              expression: "model.dest"
                            }
                          })
                        : _vm._e(),
                      _vm.model.action === "fail"
                        ? _c("gg-text-field", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: _vm.validation_rules.fail,
                                expression: "validation_rules.fail"
                              }
                            ],
                            attrs: {
                              outlined: "",
                              label: "Fail with message",
                              "data-vv-name": "fail",
                              "data-vv-as": "Fail with message",
                              "error-messages": _vm.errors.collect("fail")
                            },
                            on: {
                              input: _vm.changed
                            },
                            model: {
                              value: _vm.model.dest,
                              callback: function callback($$v) {
                                _vm.$set(_vm.model, "dest", $$v)
                              },
                              expression: "model.dest"
                            }
                          })
                        : _vm._e(),
                      _vm.model.action === "save"
                        ? _c("gg-text-field", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: _vm.validation_rules.save,
                                expression: "validation_rules.save"
                              }
                            ],
                            attrs: {
                              outlined: "",
                              label: "Deliver to folder",
                              "data-vv-name": "save",
                              "data-vv-as": "Deliver to folder",
                              "error-messages": _vm.errors.collect("save")
                            },
                            on: {
                              input: _vm.changed,
                              click: function click($event) {
                                $event.stopPropagation()
                                return _vm.openTree($event)
                              }
                            },
                            model: {
                              value: _vm.model.dest,
                              callback: function callback($$v) {
                                _vm.$set(_vm.model, "dest", $$v)
                              },
                              expression: "model.dest"
                            }
                          })
                        : _vm._e(),
                      _vm.model.action === "save" && _vm.isTreeOpen
                        ? _c("v-treeview", {
                            attrs: {
                              "load-children": _vm.getFolders,
                              items: _vm.folders,
                              activatable: "",
                              "item-text": "name",
                              "item-key": "relpath",
                              "open-on-click": "",
                              active: _vm.active
                            },
                            on: {
                              input: _vm.changed,
                              "update:active": function updateActive($event) {
                                _vm.active = $event
                              }
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "prepend",
                                  fn: function fn(_ref) {
                                    var item = _ref.item,
                                      open = _ref.open
                                    return [
                                      !item.file
                                        ? _c("v-icon", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  open
                                                    ? "mdi-folder"
                                                    : "mdi-folder"
                                                ) +
                                                " "
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              3742229178
                            ),
                            model: {
                              value: _vm.tree,
                              callback: function callback($$v) {
                                _vm.tree = $$v
                              },
                              expression: "tree"
                            }
                          })
                        : _vm._e(),
                      _vm.model.action === "pipe"
                        ? _c("gg-text-field", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: _vm.validation_rules.pipe,
                                expression: "validation_rules.pipe"
                              }
                            ],
                            attrs: {
                              outlined: "",
                              label: "Pipe to a program",
                              "data-vv-name": "pipe",
                              "data-vv-as": "Pipe to a program",
                              "error-messages": _vm.errors.collect("pipe")
                            },
                            on: {
                              input: _vm.changed
                            },
                            model: {
                              value: _vm.model.dest,
                              callback: function callback($$v) {
                                _vm.$set(_vm.model, "dest", $$v)
                              },
                              expression: "model.dest"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            {
              staticClass: "text-right",
              attrs: {
                cols: "1"
              }
            },
            [
              _c(
                "v-tooltip",
                {
                  attrs: {
                    left: ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function fn(_ref2) {
                        var on = _ref2.on
                        return [
                          _c(
                            "gg-btn",
                            _vm._g(
                              {
                                attrs: {
                                  elevation: "0",
                                  text: ""
                                },
                                on: {
                                  click: _vm.addRuleItem
                                }
                              },
                              on
                            ),
                            [_c("v-icon", [_vm._v("mdi-plus")])],
                            1
                          )
                        ]
                      }
                    }
                  ])
                },
                [_c("span", [_vm._v("Add new action")])]
              ),
              _c(
                "v-tooltip",
                {
                  attrs: {
                    left: ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function fn(_ref3) {
                        var on = _ref3.on
                        return [
                          _c(
                            "gg-btn",
                            _vm._g(
                              {
                                attrs: {
                                  elevation: "0",
                                  text: ""
                                },
                                on: {
                                  click: _vm.removeRuleItem
                                }
                              },
                              on
                            ),
                            [_c("v-icon", [_vm._v("mdi-minus")])],
                            1
                          )
                        ]
                      }
                    }
                  ])
                },
                [_c("span", [_vm._v("Delete action")])]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }